import { IState } from "@redux/store.types";
import { getValueState } from "@redux/utils";

import { $LocalesModuleName, Locale } from "./locales.types";

const getLocales = (state: IState): Array<Locale> =>
    getValueState(state, $LocalesModuleName)?.locales || [];

const getCurrentLocale = (state: IState): string =>
    getValueState(state, $LocalesModuleName)?.current || "nl";

export { getLocales, getCurrentLocale };
